<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="headers"
    :items="reviewFeedbacks"
    :rows-per-page-items="[150]"
    class="elevation-1"
    hide-default-footer
  >
    <template v-slot:items="props">
      <tr :class="{'table-row-graduate': props.item.author.graduate, 'table-row-deleted': props.item.deleted}">
        <td style="min-width: 120px;">{{ props.item.date }}</td>
        <td style="min-width: 160px;">{{ props.item.type }}</td>
        <td>{{ props.item.level }}</td>
        <td><a :href="userProfileBaseUrl + '/u/' + props.item.author.uid" target="_blank">{{ props.item.author.name }} {{ props.item.author.surname }}</a></td>
        <td>{{ props.item.authorLevel }}</td>
        <td style="min-width: 300px; max-width: 400px;">
          {{ props.item.message }}
          <br>
          {{ props.item.duration ? ('Тривалість: ' + props.item.duration + ' хв.') : ''}}
        </td>
        <td>
          {{ props.item.mark }}
          <div class="marker-square--green d-inline-block" v-if="props.item.bestReviewer"></div>
          <div class="marker-oval--orange d-inline-block" v-for="n in diffMarkArray(props.item.mark)"></div>
        </td>
        <td style="min-width: 300px; max-width: 400px;">
          {{ props.item.returnedMessage }}
          <br>
          {{ props.item.returnedDuration ? ('Тривалість: ' + props.item.returnedDuration + ' хв.') : ''}}
        </td>
        <td>
          {{ props.item.returnedMark }}
          <div class="marker-oval--orange d-inline-block" v-for="n in diffMarkArray(props.item.returnedMark)"></div>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import {urls} from "@/config";

export default {
  name: "ReviewFeedbacks",
  props: ['reviewFeedbacks'],
  data () {
    return {
      userProfileBaseUrl: urls.signin,
      headers: [
        {
          text: 'Дата',
          align: 'left',
          sortable: false,
          value: 'date',
        },
        {
          text: 'Тип',
          align: 'left',
          sortable: false,
          value: 'type',
        },
        {
          text: 'Лвл',
          align: 'left',
          sortable: false,
          value: 'level',
        },
        {
          text: 'Автор',
          align: 'left',
          sortable: false,
          value: 'author',
        },
        {
          text: 'Лвл автора',
          align: 'left',
          sortable: false,
          value: 'authorLevel',
        },
        {
          text: 'Фидбек',
          align: 'left',
          sortable: false,
          value: 'message',
        },
        {
          text: 'Оценка',
          align: 'left',
          sortable: false,
          value: 'mark',
        },
        {
          text: 'Обратный фидбек',
          align: 'left',
          sortable: false,
          value: 'returnedMessage',
        },
        {
          text: 'Обратная оценка',
          align: 'left',
          sortable: false,
          value: 'returnedMark',
        },
      ],
    }
  },

  methods: {
    diffMarkArray(currentMark) {
      if (isNaN(currentMark)) {
        return [];
      }

      const diff = 5 - currentMark;
      return [...Array(diff).keys()];
    },
    tableRowClass(item) {
      return 'table-row';
    }
  }
}
</script>

<style scoped>
  .marker-oval--orange {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-left: 2px;
    background-color: orange;
  }

  .marker-square--green {
    width: 8px;
    height: 8px;
    margin-left: 2px;
    background-color: #4caf50;
  }

  .table-row-graduate {
    background-color: #FEFFD9;
  }

  .table-row-deleted {
    background-color: #F0F0F0;
  }
</style>
